<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path
        fill="inherit"
        stroke="none"
        d="M10.08 28.67q-1.7 0-2.89-1.2T6 24.6V7.67q0-1.8 1.26-3.07a4.2 4.2 0 0 1 3.07-1.27H26v19.18a2 2 0 0 0-1.47.61 2 2 0 0 0-.6 1.47 2 2 0 0 0 .6 1.47q.6.6 1.47.6v2zM8 21.13q.46-.32.97-.47.53-.15 1.1-.15h.85V5.33h-.59q-.96 0-1.64.69Q8 6.7 8 7.67zm4.92-.62H24V5.33H12.92zm-2.84 6.16h12.46q-.3-.46-.46-.97-.16-.5-.16-1.11 0-.57.15-1.1.15-.52.47-.98H10.08q-.9 0-1.49.61-.6.6-.59 1.47a2 2 0 0 0 2.08 2.08"
      />
    </svg>
  </span>
</template>
